import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  addNotification,
  clearNotifications,
  deleteNotification,
  selectSliceNotifications,
  setNotifications,
} from '../store/reducers/notificationsReducer';

/**
 * @typedef THookUseMessages
 * @type {ReturnType<typeof useMessages>}
 */

export const useMessages = () => {
  const dispatch = useDispatch();
  const { messages } = useSelector(selectSliceNotifications);

  /**
   *
   * @param {import('../store/reducers/notificationsReducer').TNotificationItem['message']} message
   * @param {import('../store/reducers/notificationsReducer').TNotificationItem['type']=} type - message type
   * @param {string|number|null|undefined} key
   */
  const setMessage = (message, type = 'yellow', key = void 0) => {
    dispatch(addNotification({ type, message, key }));
    return self;
  };

  /**
   *
   * @param {import('../store/reducers/notificationsReducer').TNotificationItem['message']} message
   * @param {string|number|null|undefined} key
   */
  const notifyYellow = (message, key = void 0) => {
    dispatch(addNotification({ type: 'yellow', message, key }));
    return self;
  };

  /**
   *
   * @param {import('../store/reducers/notificationsReducer').TNotificationItem['message']} message
   * @param {string|number|null|undefined} key
   */
  const notifyRed = (message, key = void 0) => {
    dispatch(addNotification({ type: 'red', message, key }));
    return self;
  };

  /**
   *
   * @param {import('../store/reducers/notificationsReducer').TNotificationItem['message']} message
   */
  const notifyPurple = (message, key = void 0) => {
    dispatch(addNotification({ type: 'purple', message, key }));
    return self;
  };

  /**
   *
   * @param {import('../store/reducers/notificationsReducer').TNotificationItem['message']} message - messages
   * @param {string|number|null|undefined} key
   */
  const notifyGreen = (message, key = void 0) => {
    dispatch(addNotification({ type: 'green', message, key }));
    return self;
  };

  /**
   *
   * @param {import('../store/reducers/notificationsReducer').TNotificationItem['message']} message - messages
   * @param {import('../store/reducers/notificationsReducer').TNotificationItem['type']=} type - message type
   * @param {string|number|null|undefined} key
   */
  const addMessage = (message, type = 'yellow', key = void 0) => {
    dispatch(addNotification({ type, message, key }));
    return self;
  };

  /**
   *
   * @param {import('../store/reducers/notificationsReducer').TNotificationItem['message']} message - messages
   * @param {import('../store/reducers/notificationsReducer').TNotificationItem['type']} type - message type
   * @param {string|number|null|undefined} key
   */
  const closeMessage = (message, type, key) => {
    dispatch(deleteNotification({ message, type, key }));
    return self;
  };

  /**
   *
   * @param {(string|number|null|undefined)[]} keys
   */
  const clearByKeys = (...keys) => {
    const nextMessages = messages.filter(msg => !keys.includes(msg.key));
    dispatch(setNotifications(nextMessages));
    return self;
  };

  const clear = () => {
    dispatch(clearNotifications());
    return self;
  };

  const self = {
    rawMessages: messages ?? [],
    messages,
    addMessage,
    setMessage,
    closeMessage,
    clear,
    notifyGreen,
    notifyPurple,
    notifyRed,
    notifyYellow,
    clearByKeys,
  };

  return self;
};

export default useMessages;

export const withMessages = Component => {
  return props => {
    const messages = useMessages();
    return <Component {...props} messages={messages} />;
  };
};
